import {
  SAVE_REFERENCE,
  SAVE_REFERENCE_SUCCESS,
  SAVE_REFERENCE_FAILURE
} from './actionTypes';

const initialState = {
  isSaving: false,
  reference: {},
  error: []
};

export const newReferenceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SAVE_REFERENCE:
      return { ...state, isSaving: true };
    case SAVE_REFERENCE_SUCCESS:
      return { ...state, isSaving: false, reference: action.payload };
    case SAVE_REFERENCE_FAILURE:
      return {
        ...state,
        error: action.payload
      };
    default:
      return state;
  }
};

export const isSaving = state => state.newReference.isSaving;
export const getReference = state => state.newReference.reference;
export const getError = state => state.newReference.error;



// WEBPACK FOOTER //
// ./src/modules/ReferenceForm/reducer.js